import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Navbar from '../commonComponents/Navbar';
import Footer from '../commonComponents/Footer';
import HeadingH1 from '../utls/HeadingH1';
import './TermsAndCondition.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <div className="container terms-container mt-5 pt-md-5 mb-5">
        <HeadingH1 className="text-center headings">
          <span>Blueberry Group</span> - Privacy Policy
        </HeadingH1>

        <p className="description-terms">
          At Blueberry Group ("the Company"), accessible via <a href="https://blueberrygroup.co/">https://blueberrygroup.co/</a>, safeguarding the privacy of our visitors is one of our core commitments. This Privacy Policy outlines the types of personal data we collect and how that information is used when you visit our website. This Privacy Policy applies exclusively to information collected through our website and does not extend to offline data collection or information gathered through other channels.
        </p>

        <h5 className="sub-heading-terms">1. Consent</h5>
        <p className="content-terms">
          By accessing or using our website, you acknowledge and agree to the practices described in this Privacy Policy.
        </p>

        <h5 className="sub-heading-terms">2. Information We Collect</h5>
        <p className="content-terms">
          When you interact with our site, we may request certain personally identifiable information from you. This may include, but is not limited to, your name and contact details ("Personal Information"). This information helps us communicate with you and provide a better service.
        </p>

        <h5 className="sub-heading-terms">3. How We Use Your Information</h5>
        <p className="content-terms">
          The information collected through our website may be used for the following purposes:
          <ul>
            <li>Operating and maintaining our website</li>
            <li>Enhancing, customizing, and expanding our services</li>
            <li>Understanding how visitors interact with our platform</li>
            <li>Innovating and developing new tools, content, and offerings</li>
            <li>Responding to inquiries and providing support</li>
            <li>Sending updates, marketing messages, and relevant communications</li>
            <li>Detecting, preventing, and addressing fraudulent activity</li>
          </ul>
        </p>

        <h5 className="sub-heading-terms">4. Log Files</h5>
        <p className="content-terms">
          Like many websites, we utilize log files. These files record details such as IP addresses, browser types, ISPs, date and time stamps, referring and exit pages, and click patterns. This information is not linked to personally identifiable data and is used solely for analytics, site administration, and demographic insights.
        </p>

        <h5 className="sub-heading-terms">5. Cookies and Web Beacons</h5>
        <p className="content-terms">
          We use cookies to enhance your browsing experience. These small text files store information about your preferences and the pages you visit on our site. This allows us to tailor content and functionality to your needs.
        </p>

        <h5 className="sub-heading-terms">6. Advertising Partners Privacy Policies</h5>
        <p className="content-terms">
          Our website may feature advertisements served by third-party companies. These entities may use cookies, web beacons, and other technologies to deliver targeted ads and track ad performance. Please note that we do not have control over the cookies used by these external advertisers.
        </p>

        <h5 className="sub-heading-terms">7. Third Party Privacy Policies</h5>
        <p className="content-terms">
          This Privacy Policy does not apply to any third-party websites or services linked from our site. We advise you to review the privacy policies of these external platforms to understand how they handle your data. You can also manage cookie preferences directly through your browser settings.
        </p>

        <h5 className="sub-heading-terms">8. Security of Personal Information</h5>
        <p className="content-terms">
          We implement commercially reasonable measures—including encryption and firewalls—to secure your personal information. While we strive to protect your data, no method of online transmission or electronic storage can be guaranteed to be completely secure.
        </p>

        <h5 className="sub-heading-terms">9. Retention of Personal Information</h5>
        <p className="content-terms">
          We retain your personal information only for as long as necessary to fulfill the purposes outlined in this policy or as required by applicable law.
        </p>

        <h5 className="sub-heading-terms">10. Your Rights and Choices</h5>
        <p className="content-terms">
          Depending on your jurisdiction, you may have rights such as:
          <ul>
            <li>Accessing the personal data we hold about you</li>
            <li>Correcting or updating inaccurate data</li>
            <li>Requesting deletion of your personal information</li>
            <li>Restricting or objecting to how your data is processed</li>
            <li>Transferring your data to another service</li>
            <li>Withdrawing consent for optional data usage</li>
            <li>Filing a complaint with a data protection authority</li>
          </ul>
          To exercise any of these rights, please contact us at <a href="https://blueberrygroup.co/contact-us/">https://blueberrygroup.co/contact-us/</a>. We may require proof of identity before proceeding with your request.
        </p>

        <h5 className="sub-heading-terms">11. Children's Information</h5>
        <p className="content-terms">
          Protecting children’s privacy is important to us. We do not knowingly collect personal data from individuals under the age of 13. If you believe that a child has provided us with personal information, please notify us promptly so we can take appropriate action to delete such data.
        </p>

        <h5 className="sub-heading-terms">12. Changes to this Privacy Policy</h5>
        <p className="content-terms">
          We may periodically revise this Privacy Policy to reflect changes in our practices or for legal compliance. If any material changes are made, we will notify users via email or through a notice on our website at <a href="https://blueberrygroup.co/">https://blueberrygroup.co/</a>.
        </p>

        <h5 className="sub-heading-terms">13. Contact Information</h5>
        <p className="content-terms">
          If you have any questions or concerns regarding this Privacy Policy or your personal data, please reach out to us at <a href="mailto:info@blueberrygroup.org">info@blueberrygroup.org</a>.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;